export default __webpack_public_path__ + "static/media/IMG_1.3dd4f3ae.JPG";